export let CONFIGURATION = {
  baseUrls: {
    ServerPath: 'https://www.conversant.pro/'
    //ServerPath: 'http://dev.conversant.pro/'
     //ServerPath: 'https://localhost:44360/'
  }
}
